module.exports = __webpack_public_path__ + "img/lizegang.9f892e0a.jpg";